//MidEventPage.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import GLOBALS from '../../config/globals';
import { submitMidEventChoice } from '../../api/games';
import { translateOuts, translateEvent, buildAdvanceRunnerOptions } from '../../utils/gameUtils';
import { formatRunnerWithSpeed } from '../../helpers/cardHelpers';

const MidEventPage = ({ latestEvent, participant, onClose }) => {
    const [submitting, setSubmitting] = useState(false);
    const handleMidEventChoice = async runnersAdvancing => {
        try {
            setSubmitting(true);
            await submitMidEventChoice(runnersAdvancing, latestEvent.gameID);
            onClose(true);
        } catch (err) {
            toast.error(`Error: ${err.message}`);
        } finally {
            setSubmitting(false);
        }
    };
    // Format runners for display text
    const lineups = participant?.GameLineups;
    const firstRunner = formatRunnerWithSpeed(latestEvent.firstBaseRunnerLineup, lineups);
    const secondRunner = formatRunnerWithSpeed(latestEvent.secondBaseRunnerLineup, lineups);
    const thirdRunner = formatRunnerWithSpeed(latestEvent.thirdBaseRunnerLineup, lineups);

    //console.log(firstRunner, secondRunner, thirdRunner);
    const advancingRunners = [];
    if (firstRunner && latestEvent.resultType != GLOBALS.H1) {
        advancingRunners.push(1);
    }
    if (secondRunner && latestEvent.resultType != GLOBALS.H2) {
        advancingRunners.push(2);
    }
    if (thirdRunner && latestEvent.resultType != GLOBALS.H3) {
        advancingRunners.push(3);
    }

    const { options: advancingRunnerOptions, text: advancingRunnerText } = buildAdvanceRunnerOptions(advancingRunners);

    return (
        <div className="mid-event-page">
            <h2>Mid Event Page</h2>
            <div className="mid-event-content">
                <div className="mid-event-info">
                    <div>
                        <b>
                            {translateOuts(latestEvent.ipOuts).complete} {translateEvent(latestEvent.resultType).event}
                            !
                        </b>
                        <br />
                        {(() => {
                            const desc = latestEvent.resultDescription;
                            const loc = latestEvent.hitLocation?.replace(/_/g, ' ');
                            if (!loc || !desc.includes(loc)) return desc;
                            const idx = desc.indexOf(loc);
                            return (
                                <>
                                    {desc.slice(0, idx)}
                                    <span className="hit-location">{loc}</span>
                                    {desc.slice(idx + loc.length)}
                                </>
                            );
                        })()}
                    </div>

                    <div>
                        <br />
                        1st: {firstRunner}
                    </div>
                    <div>2nd: {secondRunner}</div>
                    <div>3rd: {thirdRunner}</div>
                    {advancingRunnerOptions.length ? (
                        <>
                            <br />
                            {advancingRunnerOptions.map((opt, idx) => {
                                return (
                                    <>
                                        <button
                                            key={idx}
                                            onClick={() => handleMidEventChoice(opt)}
                                            className={submitting ? 'inactive' : ''}
                                            disabled={submitting}
                                        >
                                            {advancingRunnerText[idx]}
                                        </button>
                                        <br />
                                    </>
                                );
                            })}
                            <button onClick={() => handleMidEventChoice(null)} className={submitting ? 'inactive' : 'danger-action'} disabled={submitting}>
                                Hold Runners
                            </button>
                        </>
                    ) : (
                        <></>
                    )}
                </div>

                {/* BaseballDiamond removed — component preserved for future use */}
            </div>
        </div>
    );
};

MidEventPage.propTypes = {
    participant: PropTypes.object,
    latestEvent: PropTypes.shape({
        gameID: PropTypes.number.isRequired,
        resultDescription: PropTypes.string.isRequired,
        resultType: PropTypes.string.isRequired,
        ipOuts: PropTypes.number.isRequired,
        hitLocation: PropTypes.string,
        firstBaseRunnerLineup: PropTypes.shape({
            Card: PropTypes.shape({
                year: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                speed: PropTypes.number.isRequired,
            }),
        }),
        secondBaseRunnerLineup: PropTypes.shape({
            Card: PropTypes.shape({
                year: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                speed: PropTypes.number.isRequired,
            }),
        }),
        thirdBaseRunnerLineup: PropTypes.shape({
            Card: PropTypes.shape({
                year: PropTypes.number.isRequired,
                name: PropTypes.string.isRequired,
                speed: PropTypes.number.isRequired,
            }),
        }),
    }).isRequired,
    onClose: PropTypes.func.isRequired,
};

export default MidEventPage;
